import { render, staticRenderFns } from "./ButtonCheckbox.vue?vue&type=template&id=5c68265c&scoped=true"
import script from "./ButtonCheckbox.vue?vue&type=script&lang=js"
export * from "./ButtonCheckbox.vue?vue&type=script&lang=js"
import style0 from "./ButtonCheckbox.vue?vue&type=style&index=0&id=5c68265c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c68265c",
  null
  
)

export default component.exports